<div class="container-fluid spacer-top-navigation" id="crypto-list">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-2">
        <div class="tile">
          <div class="row">
            <div class="col-12">
              <h1 class="zero-text p-huge-med">
                {{ 'crypto.overview.crypto_headline' | transloco }}
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex mt-3">
              <web-design-system-button class="mr-2" type="secondary" size="small" (click)="scrollTo.emit('CRYPTOS')">
                {{ 'crypto.overview.crypto_headline' | transloco }}
              </web-design-system-button>
              <web-design-system-button type="secondary" size="small" (click)="scrollTo.emit('ETPS')">
                {{ 'crypto.overview.etp_headline' | transloco }}
              </web-design-system-button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="mt-4" [innerHTML]="'crypto.overview.crypto_hint' | transloco"></p>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <h5>{{ 'crypto.overview.popular_cryptos' | transloco }}</h5>
            </div>
          </div>
          <table class="table-depot align-text-top" aria-describedby="crypto-list">
            <thead class="with-border">
              <tr>
                <th></th>
                <th>
                  {{ 'crypto.overview.quote' | transloco }}
                </th>
                <th>
                  {{ 'crypto.overview.perf' | transloco }}
                  <br />
                  {{ 'crypto.overview.perfAbsolut' | transloco }}
                </th>
                <th>
                  {{ 'crypto.overview.time' | transloco }}
                  <br />
                  {{ 'crypto.overview.date' | transloco }}
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              @for (crypto of popularCryptos; track crypto.isin) {
                <tr crypto-crypto-list-item [crypto]="crypto"></tr>
              }
            </tbody>

            <div class="row mt-3">
              <div class="col-12">
                <h5>{{ 'crypto.overview.more_cryptos' | transloco }}</h5>
              </div>
            </div>

            <tbody>
              @for (crypto of cryptos | orderBy: 'description'; track crypto.isin) {
                <tr crypto-crypto-list-item [crypto]="crypto"></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
